import req from "@/request.js";
const uc = req.getContext().uc;
const bpmRunTime = req.getContext().bpmRunTime;
export default {
    getCurrent(cb) {
        req.post(uc + `/api/user/v1/user/getByAccount`).then(rep => {
            cb(rep);
        });
    },
    //当前用户的组织岗位信息存入redis
    putInCacheOrgPost(data,cb) {
        let map = {data:JSON.stringify(data)};
        req.post(uc + `/api/user/v1/putInCacheOrgPost`,map).then(rep => {
            cb(rep.data);
        });
    },
    setMasterByorgId(data,cb) {
        req.put(bpmRunTime + '/bpm/haiyaScript/setMasterByorgId?orgid=' + data.orgid + '&userid='+data.userid).then(resp => {
            cb(resp.data)
        })
    },
    //根据Key获取当前用户的组织岗位信息存入redis
    getCacheByKeyOrgPost(cb) {
        req.post(uc + `/api/user/v1/getCacheByKeyOrgPost`).then(rep => {
            cb(rep.data);
        });
    },
    getUserByAccount(account, cb) {
        req.get(uc + `/api/user/v1/user/getDetailByAccountOrId?account=${account}`).then(rep => {
            cb(rep.data);
        });
    },

    authentication(principal, cb, errorCb) {
        req.post(uc + `/auth?tenantId=${principal.tenantId || '' }`, {
            username: principal.account,
            password: principal.password
        }).then(function (rep) {
            cb(rep.data);
        }).catch(function (error) {
            if (error.response && error.response.data && error.response.data.message) {
                errorCb(error.response.data.message);
            }else{
                errorCb(error.message);
            }

        });
    },

    basicSso(token, cb, errorCb) {
        let service = localStorage.getItem("service");
        req.get(uc+`/sso/auth?ticket=${token}&code=${token}&service=${service}`).then(function (rep) {
        	if (!window.ssoConfig.mode || window.ssoConfig.mode == "jwt") {
        		if(token.substr(0, 1)===' '){
        			token = token.substr(1);
        		}
        		rep.data.token = token;
        	}
        	cb(rep.data);
        }).catch(function (error) {
            errorCb(error.message);
        });
    },

    modifyPwd(data, cb) {
        req.post(uc + `/api/user/v1/user/changUserPsd`, data).then(rep => {
            cb(rep.data)
        });
    },

    getAllDimension(cb, errorCb) {
        req.get(uc + '/api/demension/v1/dems/getAll')
            .then(function (rep) {
                cb(rep.data);
            })
            .catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },

    getOrgsByDemension(demensionId, cb, errorCb) {
        req.post(uc + '/api/org/v1/orgs/getByParentAndDem', {
            demId: demensionId
        }).then(function (rep) {
            cb(rep.data);
        }).catch(function (error) {
            errorCb && errorCb(error.message);
        });
    },

    getOrgsByParentIdAndDemension(parentId, demensionId, cb, errorCb) {
        req.post(uc + '/api/org/v1/orgs/getByParentAndDem', {
            demId: demensionId,
            parentId: parentId
        }).then(function (rep) {
            cb(rep.data);
        }).catch(function (error) {
            errorCb && errorCb(error.message);
        });
    },

    getUsersByOrgId(queryFilter, cb, errorCb) {
        req.post(uc + '/api/user/v1/users/queryUserWithMainOrgPost', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },

    loadUsersByGropuId(queryFilter, cb, errorCb) {
        req.post(uc + '/api/user/v1/users/loadUsersByGropuId', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
            errorCb && errorCb(error.message);
        });
    },

    getCurrentOrg(cb) {
        req.get(uc + `/api/org/v1/org/getOrgMaster`).then(rep => {
            cb(rep);
        });
    },

    queryOrgByFilter(queryFilter, cb, errorCb) {
        req.post(uc + '/api/org/v1/orgs/getOrgPage', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },
    getOrgPostPage(queryFilter, cb, errorCb) {
        req.post('/api/org/v1/orgPosts/getOrgPostPage', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },
    getRolePage(queryFilter, cb, errorCb) {
        req.post('/api/role/v1/roles/getRolePage', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },
    getJobPage(queryFilter, cb, errorCb) {
        req.post('/api/job/v1/jobs/getJobPage', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },
    //查询维度列表
    getDemPage(queryFilter, cb, errorCb) {
        req.post(uc + '/api/demension/v1/dems/getDemListAll', queryFilter)
            .then(function (rep) {
                cb(rep);
            }).catch(function (error) {
                errorCb && errorCb(error.message);
            });
    },
    //获取默认密码策略
    getDefaultPwdStrategy() {
        return new Promise((resolve, reject) => {
            req.get(`${uc}/api/pwdStrategy/v1/getDefault`).then(
                resp => {
                    resolve(resp.data);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    getDefPwdStrategy(cb) {
        req.get(uc + "/api/pwdStrategy/v1/getDefault").then(response => {
            cb(response.data);
        });
    },
}
